export interface Model {
	_id: string;
}